<template>
  <div class="team-member-tags">
    <div v-if="hint" class="team-hint">{{ hint }}</div>
    <div class="tags-wrap">
      <template v-for="(tag, index) in innerTags">
        <a-tag
          :key="index"
          class="member-tag"
          :closable="!disabled"
          @close="handleClose(tag)"
        >
          {{ tag }}
        </a-tag>
      </template>
      <a-input
        v-if="inputVisible"
        ref="tagInput"
        type="text"
        size="small"
        class="tag-input"
        :value="inputValue"
        :maxLength="30"
        placeholder="输入后回车"
        @change="handleInputChange"
        @blur="handleInputConfirm"
        @keyup.enter="handleInputConfirm"
      />
      <a-tag
        v-else-if="!disabled && innerTags.length < max"
        class="add-tag"
        @click="showInput"
      >
        <a-icon type="plus" />添加成员
      </a-tag>
    </div>
  </div>
</template>

<script>
export default {
  name: "TeamMemberTags",
  props: {
    value: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    max: { type: Number, default: 20 },
    hint: {
      type: String,
      default: "非本校教师请注明所属学校，如：张三(某某学校)",
    },
  },
  data() {
    return {
      innerTags: [],
      inputVisible: false,
      inputValue: "",
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        const parsed = this.parseTeams(val);
        const cur = this.innerTags.join(",");
        const next = parsed.join(",");
        if (cur !== next) {
          this.innerTags = parsed;
        }
      },
    },
  },
  methods: {
    parseTeams(str) {
      if (!str) return [];
      return String(str)
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
    },
    emitTeams() {
      const teams = this.innerTags.join(",");
      this.$emit("input", teams);
      this.$emit("change", teams);
    },
    handleClose(removedTag) {
      if (this.disabled) return;
      this.innerTags = this.innerTags.filter((tag) => tag !== removedTag);
      this.emitTeams();
    },
    showInput() {
      if (this.disabled) return;
      this.inputVisible = true;
      this.$nextTick(() => {
        const input = this.$refs.tagInput;
        if (input && input.focus) input.focus();
      });
    },
    handleInputChange(e) {
      this.inputValue = e.target.value;
    },
    handleInputConfirm() {
      if (this.disabled) return;
      const inputValue = (this.inputValue || "").trim();
      if (!inputValue) {
        this.inputVisible = false;
        this.inputValue = "";
        return;
      }
      if (inputValue.length > 30) {
        this.$message.warn("单个成员名称不能超过30字");
        return;
      }
      if (this.innerTags.length >= this.max) {
        this.$message.warn(`团队成员不能超过${this.max}人`);
        return;
      }
      if (this.innerTags.indexOf(inputValue) === -1) {
        this.innerTags = [...this.innerTags, inputValue];
        this.emitTeams();
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
  },
};
</script>

<style scoped lang="scss">
.team-member-tags {
  flex: 1;
  min-width: 0;
}
.team-hint {
  font-size: 12px;
  color: #888;
  margin-bottom: 8px;
}
.tags-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.member-tag {
  margin: 0;
  font-size: 14px;
  padding: 4px 10px;
}
.add-tag {
  background: #fff;
  border-style: dashed;
  cursor: pointer;
  margin: 0;
}
.tag-input {
  width: 150px;
}
</style>
